import styled from "styled-components"

export const Wrapper = styled.div`
  position:absolute;
  bottom:0;
  left:50%;
  width:660px;
  margin-left:-330px;
  height:268px;
  background: rgba(0,0,0,.6);
  border-bottom:none;
  border-radius:8px 8px 0 0;
`
